<template>
  <div class="main-area">
    <el-breadcrumb separator=":">
      <el-breadcrumb-item>当前位置</el-breadcrumb-item>
      <el-breadcrumb-item>清倒点管理列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--查询区域-->
    <el-row class="margin-top-10">
      <el-col :span="1" class="margin-top-10">
        <label class="search-label">
          乡镇:
        </label>
      </el-col>
      <el-col :span="4" class="margin-top-10">
        <el-select v-model="searchForm.xzUuid"
                   :size="GLOBAL.config.systemSize"
                   placeholder="请选择"
                   style="width: 100%;" clearable>
          <el-option :label="item.name" :value="item.code"
                     v-for="item in xzList"
                     :key="item.code"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2" class="margin-top-10">
        <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
        </el-button>
      </el-col>
    </el-row>
    <el-row class="margin-top-20">
      <el-col :span="24">
        <el-button v-if="source.add"
                   type="primary"
                   icon="el-icon-plus"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   @click="operationMethod('add')">新增
        </el-button>
        <!-- <el-button v-if="source.deleteBatch"
                   type="danger"
                   icon="el-icon-delete"
                   :size="GLOBAL.config.systemSize"
                   style="float: left;"
                   :disabled="deleteBatchList.ids.length === 0"
                   @click="deleteBatch">批量删除
        </el-button> -->
      </el-col>
    </el-row>
    <el-table style="width: 100%"
              :data="tableData"
              @selection-change="tableSelectionChange"
              element-loading-text="数据处理中...请稍等..."
              v-loading="loading">
      <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
      <!--姓名-->
      <el-table-column prop="xz" label="所属乡镇" align="center"/>
      <el-table-column prop="qddName" label="清倒点名称" align="center"/>
      <el-table-column prop="lng" label="经度" align="center"/>
      <el-table-column prop="lat" label="纬度" align="center"/>
<!--      <el-table-column prop="cjsj" label="创建时间" :formatter="formatterTime"></el-table-column>-->
      <el-table-column prop="scope" label="操作" align="center">
        <template slot-scope="scope">
          <el-dropdown>
                <span class="el-dropdown-link operator-text">
                  选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)"
                                :key="item.method"
                                @click.native="handleCommon(item.method, scope.row)">
                {{item.title}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="margin-top-10 margin-bottom-20"
      @size-change="tableSizeChange"
      @current-change="currentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagination.pageSizeList"
      :page-size="pagination.pageSize"
      :layout="pagination.layout"
      :total="pagination.total">
    </el-pagination>
    <el-dialog
      :title="showTitle"
      :visible.sync="showFlag"
      @close="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        :inline="true"
        :model="formData"
        class="demo-ruleForm"
        label-width="140px"
        :rules="formRules"
        ref="formData"
        :size="GLOBAL.config.systemSize"
        element-loading-text="数据处理中...请稍等..."
        :disabled="!editableFlag"
        v-loading="loading">
        <el-row class="margin-top-20">
          <el-col :span="24">
            <el-form-item label="所属乡镇：" prop="xzUuid">
              <el-select v-model="formData.xzUuid"
                         :size="GLOBAL.config.systemSize"
                         placeholder="请选择"
                         style="width: 100%;" clearable :disabled="bjFlag">
                <el-option :label="item.name" :value="item.code"
                           v-for="item in xzList"
                           :key="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="清倒点名称：" prop="qddName">
              <el-input v-model="formData.qddName" placeholder="清倒点名称" maxlength="64" :disabled="bjFlag"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="清倒范围(米)：" prop="jl">
              <el-input v-model="formData.jl" placeholder="清倒范围" maxlength="64" :disabled="bjFlag"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="经度：" prop="lng">
              <el-input v-model="formData.lng" placeholder="经度" maxlength="64" :disabled="bjFlag"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="纬度：" prop="lat">
              <el-input v-model="formData.lat" placeholder="纬度" maxlength="64" :disabled="bjFlag"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="margin-top-20">
        <el-button @click="closeDialog" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
        <el-button v-if="!bjFlag" type="primary" @click="saveBtn" style="margin: 0 20px;"
                   :size="GLOBAL.config.systemSize">保存
        </el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
    export default {
        name: 'QddManage',
        data () {
            return {
                xzList: JSON.parse(localStorage.getItem('xzList')),
                yhqx: JSON.parse(localStorage.getItem('gcUserInfo')).yhqx,
                // 查询表单
                searchForm: {
                    xzUuid: ''
                },
                tableData: [],
                // 字典数据
                dictionary: {
                    treeData: []
                },
                // 资源权限控制，有的系统不需这么细，则全部为true
                source: {
                    add: true,
                    deleteBatch: true,
                    infoEdit: true,
                    infoView: true,
                    infoDelete: true,
                    resetPwd: true,
                    weChat: true
                },
                // 分页参数
                pagination: {
                    pageSizeList: [10, 20, 30, 40, 50],
                    pageSize: 10,
                    layout: 'total, sizes, prev, pager, next, jumper',
                    total: 0,
                    currentPage: 1
                },
                operationVisibleFlag: false,
                deleteBatchList: {
                    ids: [],
                    deleteFlag: false
                },
                loading: false,
                defaultProps: {
                    checkStrictly: true,
                    label: 'shortName',
                    value: 'id',
                    children: 'children',
                    expandTrigger: 'hover'
                },
                showTitle: '新增清倒点',
                showFlag: false,
                formData: {
                    xzUuid: '',
                    qddName: '',
                    jl: '',
                    lng: '',
                    lat: ''
                },
                formRules: {
                    xzUuid: [{required: true, message: '请选择乡镇', trigger: 'blur'}],
                    qddName: [{required: true, message: '请输入清倒点名称', trigger: 'blur'}],
                    jl: [{required: true, message: '请输入清倒范围（整数）', trigger: 'blur'}],
                    lng: [{required: true, message: '请输入经度', trigger: 'blur'}],
                    lat: [{required: true, message: '请输入纬度', trigger: 'blur'}],
                },
                editableFlag: true,
                bjFlag: false
            }
        },
        components: {
        },
        mounted () {
            this.init()
        },
        methods: {
            init: function () {
                // TODO 加载列表数据
                this.getTableData('init')
            },
            doSearch: function () {
                this.getTableData('init')
            },
            // 表单制空
            clearFormData: function () {
                this.formData = {
                    xzUuid: '',
                    qddName: '',
                    jl: '',
                    lng: '',
                    lat: ''
                }
            },
            operationMethod: function (operateType, info) {
                this.clearFormData()
                this.showTitle = '新增清倒点'
                this.showFlag = true
            },
            // 关闭
            closeDialog: function () {
                this.showFlag = false
            },
            deleteBatch: function () {
                let _this = this
                _this.$confirm('确认删除当前选择' +
                    '的' + _this.deleteBatchList.ids.length + '条数据？？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.loading = true
                    _this.FUNCTIONS.systemFunction.interactiveData(
                        _this,
                        _this.GLOBAL.config.businessFlag.zxUser,
                        _this.GLOBAL.config.handleType.deleteLogicalBatch,
                        _this.deleteBatchList.ids,
                        'list',
                        resultData => {
                            _this.loading = false
                            if (resultData) {
                                _this.$message.success('删除成功～')
                                _this.getTableData('init')
                            } else {
                                _this.$message.warning('删除失败～')
                            }
                        }
                    )
                })
            },
            getSource: function (rowData) {
                let tempList = []
                this.source.infoView && tempList.push({icon: 'el-icon-view', title: '查看', method: 'handleView'})
                if (rowData.yhqx != '5') {
                    this.source.infoEdit && tempList.push({icon: 'el-icon-edit', title: '编辑', method: 'handleEdit'})
                }
                if (rowData.yhqx != '3' && rowData.yhqx != '5') {
                    this.source.infoDelete && tempList.push({icon: 'el-icon-delete', title: '删除', method: 'handleDelete'})
                }
                return tempList
            },
            handleCommon: function (type, rowData) {
                switch (type) {
                    case 'handleEdit':
                        this.handleEdit(rowData)
                        break
                    case 'handleView':
                        this.handleView(rowData)
                        break
                    case 'handleDelete':
                        this.handleDelete(rowData)
                        break
                }
            },
            // 编辑
            handleEdit: function (rowData) {
                this.clearFormData()
                this.formData = rowData
                this.showTitle = '修改清倒点'
                this.bjFlag = false
                this.showFlag = true
                // TODO
            },
            // 查看
            handleView: function (rowData) {
                this.clearFormData()
                this.formData = rowData
                this.showTitle = '查看清倒点'
                this.bjFlag = true
                this.showFlag = true
                // TODO
            },
            // dialog保存按钮
            saveBtn: function () {
                if (this.formData.uuid) {
                    this.updateForm()
                } else {
                    this.saveForm()
                }
            },
            // 新增保存
            saveForm: function () {
                let _this = this;
                this.$refs.formData.validate(valid => {
                    if (valid) {
                        let params =  _this.formData
                        params.xz = _this.getXzName(params.xzUuid)
                        params.baseService = "TGcQddServiceImpl";
                        _this.FUNCTIONS.systemFunction.interactiveData(
                            _this,
                            _this.GLOBAL.config.businessFlag.zxUser,
                            'add',
                            params,
                            null,
                            resultData => {
                                _this.loading = false
                                if (resultData) {
                                    if (resultData.code == '200') {
                                        _this.$message.success('保存成功～')
                                        _this.showFlag = false
                                        _this.getTableData('init')
                                    } else {
                                        _this.$message.warning(resultData.errorMsg)
                                    }
                                } else {
                                    _this.$message.warning('保存失败～')
                                }
                            },
                            () => {
                                _this.$message.warning('保存失败～请联系管理员')
                            }
                        )
                    } else {
                        return false
                    }
                })
            },
            // 修改保存
            updateForm: function () {
                let _this = this;
                this.$refs.formData.validate(valid => {
                    if (valid) {
                        let params =  _this.formData
                        params.xz = _this.getXzName(params.xzUuid)
                        params.baseService = "TGcQddServiceImpl";
                        _this.FUNCTIONS.systemFunction.interactiveData(
                            _this,
                            _this.GLOBAL.config.businessFlag.zxUser,
                            'updateAll',
                            params,
                            null,
                            resultData => {
                                _this.loading = false
                                if (resultData) {
                                    if (resultData.code == '200') {
                                        _this.$message.success('保存成功～')
                                        _this.showFlag = false
                                        _this.getTableData('init')
                                    } else {
                                        _this.$message.warning(resultData.errorMsg)
                                    }
                                } else {
                                    _this.$message.warning('保存失败～')
                                }
                            },
                            () => {
                                _this.$message.warning('保存失败～请联系管理员')
                            }
                        )
                    } else {
                        return false
                    }
                })
            },

            // 单条数据删除
            handleDelete: function (rowData) {
                let _this = this
                let param = {
                    info: rowData.uuid,
                    baseService: 'TGcQddServiceImpl',
                    type: 'deletePhysical'
                }
                _this.$confirm('确认删除当前数据？？', '提示', {
                }).then(() => {
                    _this.FUNCTIONS.systemFunction.jsonPost(
                        _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                        param,
                        resultData => {
                            _this.loading = false
                            if (resultData) {
                                _this.$message.success('删除成功～')
                                _this.getTableData('init')
                            } else {
                                _this.$message.warning('删除失败～')
                            }
                        }
                    )
                })
            },
            // 获取列表
            getTableData: function (initPageFlag) {
                this.loading = true
                let _this = this, searchParams = this.searchForm;
                _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
                let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
                    initPageFlag ? 1 : _this.pagination.currentPage,
                    initPageFlag ? 10 : _this.pagination.pageSize,
                    searchParams)
                // 3、 调接口获取数据
                paginationData.baseService = 'TGcQddServiceImpl'
                _this.FUNCTIONS.systemFunction.interactiveData(
                    _this,
                    _this.GLOBAL.config.businessFlag.zxUser,
                    'getPageByXz',
                    paginationData,
                    null,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            // 结果参数赋值
                            _this.pagination.pageSize = resultData.obj.size
                            _this.pagination.total = resultData.obj.total
                            _this.pagination.currentPage = resultData.obj.current
                            _this.tableData = resultData.obj.records
                        } else {
                            _this.$message.warning('获取列表数据失败～')
                        }
                    },
                    () => {
                        _this.loading = false
                    }
                )
            },
            // 分页方法
            tableSizeChange: function (pageSize) {
                this.pagination.pageSize = pageSize
                this.getTableData()
            },
            currentChange: function (current) {
                this.pagination.currentPage = current
                this.getTableData()
            },
            // 复选框选择事件
            tableSelectionChange: function (targetList) {
                let ids = []
                targetList.forEach(item => {
                    ids.push(item.id)
                })
                this.deleteBatchList.ids = ids
                if (this.deleteBatchList.ids &&
                    this.deleteBatchList.ids.length > 0) {
                    this.deleteBatchList.deleteFlag = true
                } else {
                    this.deleteBatchList.deleteFlag = false
                }
            },
            formatterTime(row, column, data) {
                if (!data) {
                    return "";
                }
                var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                return data.replace(reg, "$1-$2-$3 $4:$5:$6");
            },
            // 获取乡镇名字
            getXzName(code) {
                let name = ''
                for (let i = 0; i < this.xzList.length; i++) {
                    if (code === this.xzList[i].code) {
                        name = this.xzList[i].name
                    }
                }
                return name
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/setFunction/QddManage.vue